module.exports = __webpack_public_path__ + "static/media/selfDefense.12710cca.svg";